import React from "react";
import PropTypes from "prop-types";

import { debounce } from "@/utils";

class ConfirmContent extends React.Component {
  constructor(props) {
    super(props);

    this.scrollableRef = React.createRef();
    this.scrollDebounce = debounce(this.scroll);
  }

  componentDidMount() {
    this.scrollableRef.current.addEventListener("scroll", this.scrollDebounce);
    const { onRead } = this.props;
    this.scrollableRef.current.scrollHeight <=
      this.scrollableRef.current.clientHeight &&
      this.scrollableRef.current.clientHeight > 0 &&
      onRead &&
      onRead();
  }

  componentWillUnmount() {
    this.scrollableRef.current.removeEventListener(
      "scroll",
      this.scrollDebounce
    );
    this.scrollDebounce.cancel();
  }

  scroll = (e) => {
    const { onRead } = this.props;
    const { clientHeight, scrollHeight, scrollTop } = e.target;
    const isBottom = scrollTop + clientHeight + 20 > scrollHeight;
    isBottom && onRead && onRead();
  };

  render() {
    const { content, className } = this.props;
    return (
      <div
        ref={this.scrollableRef}
        className={`confirm-content-container ${className || ""}`}
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    );
  }
}

ConfirmContent.propTypes = {
  content: PropTypes.string,
  onRead: PropTypes.func,
};

export default ConfirmContent;
